import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'
import { RouteProps } from 'react-router'
import queryString from 'qs'

import { renderTextField, Submit } from '../form'
import { validRequired, validPassword } from '../form/validate'

import { FieldWrapper } from './styles'
import { AuthToken } from './shared'

interface NewPasswordFormValues {
  user: {
    password: string
    password_confirmation: string
  }
}
interface NewPasswordFormProps {
  location: RouteProps['location']
}

const NewPassword = ({
  location,
  handleSubmit,
  pristine,
}: NewPasswordFormProps & InjectedFormProps) => {
  const [form, setForm] = useState(null)
  const { reset_password_token: resetToken } = queryString.parse(
    location.search,
    {
      ignoreQueryPrefix: true,
    }
  )

  return (
    <form
      className="qa-change-password"
      action="/users/password"
      method="post"
      ref={(ref: HTMLFormElement) => setForm(ref)}
      onSubmit={handleSubmit(() => {
        form.submit()
      })}
    >
      <AuthToken />
      <input type="hidden" name="_method" value="put" />
      <input
        type="hidden"
        value={resetToken as string}
        name="user[reset_password_token]"
      />

      <FieldWrapper>
        <Field
          label="New password"
          name="user[password]"
          type="password"
          component={renderTextField}
          validate={[validRequired, validPassword]}
          noMargin
        />
      </FieldWrapper>

      <FieldWrapper margin="medium">
        <Field
          label="Confirm new password"
          name="user[password_confirmation]"
          type="password"
          component={renderTextField}
          validate={[validRequired, validPassword]}
          noMargin
        />
      </FieldWrapper>

      <FieldWrapper>
        <Submit name="commit" disabled={pristine} fullwidth uppercase={false}>
          Change password
        </Submit>
      </FieldWrapper>
    </form>
  )
}

const NewPasswordForm = reduxForm<NewPasswordFormValues, NewPasswordFormProps>({
  form: 'NewPassword',
})(NewPassword)

export default connect()(NewPasswordForm)
